import { render, staticRenderFns } from "./OrganizationPerimeterSelect.vue?vue&type=template&id=755451af"
import script from "./OrganizationPerimeterSelect.vue?vue&type=script&lang=js"
export * from "./OrganizationPerimeterSelect.vue?vue&type=script&lang=js"
import style0 from "./OrganizationPerimeterSelect.vue?vue&type=style&index=0&id=755451af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports